import axios, { AxiosResponse } from 'axios';
import { toast } from 'react-toastify';
import testMockData from '../utils/mockData';

const interceptor: any = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL, // our API base URL
});

const isFormDataBody = (data: unknown): data is FormData =>
    typeof FormData !== "undefined" && data instanceof FormData;

interceptor.interceptors.response.use((_response: AxiosResponse<any>) => {
    return _response;
}, (_error: any) => {
    const message = _error?.response?.data?.message ?? _error?.message ?? "Request failed.";
    toast.error(message, { autoClose: 1000, position: "top-center"});
    return Promise.reject(_error);
})

// Request interceptor for adding the bearer token
interceptor.interceptors.request.use(
    (config: any) => {
        if (isFormDataBody(config.data)) {
            // The browser must add the multipart boundary to this header.
            delete config.headers['Content-Type'];
        } else {
            config.headers['Content-Type'] = "application/json";
        }
        let token = localStorage.getItem('persist:root') ? JSON.parse(JSON.parse(localStorage.getItem('persist:root') ?? "").auth).token : null; // Assuming you store the token in localStorage
        if (process.env.NODE_ENV === 'test') {
            token = testMockData.authToken
        }
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error: any) => {
        return Promise.reject(error);
    }
);

// Export the api instance
export default interceptor;
